export const types = {
	show: 'LOADING_SHOW',
	close: 'LOADING_REMOVE',
};
